import { Typography } from "@mui/material"
import { Grid } from "@mui/material"

export function AuthError() {
    return (
        <div>
            <Grid item gap={3} sx={{ mt: 3, height: '100vh' }}>
                <Typography variant="h1" component="h2" textAlign='center'>
                    403 Forbidden
                </Typography>
                <Typography variant="h3" component="div" textAlign='center'>
                    このページは閲覧できません。
                </Typography>
            </Grid>
        </div>
    )
}